import main_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/main.jpeg";
import one_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/one.jpg";
import two_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/two.jpg";
import three_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/three.jpg";
import four_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/four.jpg";
import five_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/five.jpg";
import six_tre_donne_2015 from "../assets/shows_images/2015_tre_donne_guai/six.jpg";

import main_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/main.jpg";
import one_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/one.jpg";
import two_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/two.jpg";
import three_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/three.jpg";
import four_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/four.jpg";
import five_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/five.jpg";
import six_medeia_medeias_2015 from "../assets/shows_images/2015_medeia_medeias_medeia/six.jpg";

import main_medea_2016 from "../assets/shows_images/2016_medea/main.jpg";
import one_medea_2016 from "../assets/shows_images/2016_medea/one.jpg";
import two_medea_2016 from "../assets/shows_images/2016_medea/two.jpg";
import three_medea_2016 from "../assets/shows_images/2016_medea/three.jpg";
import four_medea_2016 from "../assets/shows_images/2016_medea/four.jpg";
import five_medea_2016 from "../assets/shows_images/2016_medea/five.jpg";
import six_medea_2016 from "../assets/shows_images/2016_medea/six.jpg";

import main_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/main.png";
import one_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/one.jpg";
import two_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/two.jpg";
import three_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/three.jpg";
import four_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/four.jpg";
import five_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/five.jpg";
import six_sogno_mezza_estate_2016 from "../assets/shows_images/2016_sogno_mezza_estate/six.jpg";

import main_menecmi_2017 from "../assets/shows_images/2017_menecmi/main.jpg";
import one_menecmi_2017 from "../assets/shows_images/2017_menecmi/one.jpg";
import two_menecmi_2017 from "../assets/shows_images/2017_menecmi/two.jpg";
import three_menecmi_2017 from "../assets/shows_images/2017_menecmi/three.jpg";
import four_menecmi_2017 from "../assets/shows_images/2017_menecmi/four.jpg";
import five_menecmi_2017 from "../assets/shows_images/2017_menecmi/five.JPG";
import six_menecmi_2017 from "../assets/shows_images/2017_menecmi/six.jpg";

import main_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/main.jpg";
import one_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/one.jpg";
import two_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/two.jpg";
import three_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/three.jpg";
import four_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/four.jpg";
import five_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/five.jpg";
import six_quattro_donne_canaglia_2017 from "../assets/shows_images/2017_quattro_donne_canaglia/six.jpg";

import main_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/main.jpg";
import one_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/one.jpg";
import two_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/two.jpg";
import three_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/three.jpg";
import four_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/four.jpg";
import five_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/five.jpg";
import six_sogno_mezza_estate_2017 from "../assets/shows_images/2017_sogno_mezza_estate/six.jpg";

import main_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/main.jpg";
import one_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/one.jpg";
import two_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/two.jpg";
import three_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/three.jpg";
import four_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/four.jpg";
import five_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/five.jpg";
import six_mostellaria_terza_2018 from "../assets/shows_images/2018_mostellaria_terza/six.jpg";

import main_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/main.jpg";
import one_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/one.jpg";
import two_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/two.jpg";
import three_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/three.jpg";
import four_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/four.jpg";
import five_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/five.jpg";
import six_due_donne_fuga_2018 from "../assets/shows_images/2018_due_donne_fuga/six.jpg";

import main_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/main.jpg";
import one_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/one.jpg";
import two_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/two.jpg";
import three_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/three.jpg";
import four_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/four.jpg";
import five_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/five.jpg";
import six_mostellaria_2019 from "../assets/shows_images/2019_mostellaria/six.jpg";

import main_due_donne_fuga_2019 from "../assets/shows_images/2019_due_donne_fuga/main.jpg";

import main_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/main.jpeg";
import one_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/one.jpg";
import two_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/two.jpg";
import three_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/three.jpg";
import four_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/four.jpg";
import five_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/five.jpg";
import six_lysistrata_2020 from "../assets/shows_images/2020_lysistrata/six.jpg";

import main_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/main.jpg";
import one_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/one.jpg";
import two_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/two.jpg";
import three_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/three.jpg";
import four_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/four.jpg";
import five_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/five.jpg";
import six_romeo_giulietta_2021 from "../assets/shows_images/2021_romeo_giulietta/six.jpg";

import main_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/main.jpeg";
import one_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/one.jpg";
import two_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/two.jpg";
import three_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/three.jpg";
import four_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/four.jpg";
import five_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/five.jpg";
import six_sette_contro_tebe_2021 from "../assets/shows_images/2021_sette_contro_tebe/six.jpg";

import main_vantone_2022 from "../assets/shows_images/2022_vantone/main.jpg";
import one_vantone_2022 from "../assets/shows_images/2022_vantone/one.jpeg";
import two_vantone_2022 from "../assets/shows_images/2022_vantone/two.jpeg";
import three_vantone_2022 from "../assets/shows_images/2022_vantone/three.jpg";
import four_vantone_2022 from "../assets/shows_images/2022_vantone/four.jpg";
import five_vantone_2022 from "../assets/shows_images/2022_vantone/five.jpeg";
import six_vantone_2022 from "../assets/shows_images/2022_vantone/six.jpeg";

import main_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/main.png";
import one_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/one.jpg";
import two_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/two.jpg";
import three_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/three.jpg";
import four_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/four.jpg";
import five_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/five.jpg";
import six_fortuna_notte_luna_2022 from "../assets/shows_images/2022_fortuna_notte_luna/six.jpg";

import main_rigoletto_2022 from "../assets/shows_images/2022_rigoletto/main.jpg";

import main_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/main.jpeg";
import one_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/one.jpg";
import two_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/two.jpg";
import three_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/three.jpg";
import four_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/four.jpg";
import five_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/five.jpg";
import six_rumori_fuori_scena_2022 from "../assets/shows_images/2022_rumori_fuori_scena/six.jpg";

import main_sette_contro_tebe_2022 from "../assets/shows_images/2022_sette_contro_tebe/main.jpeg";

import main_tartufo_2022 from "../assets/shows_images/2022_tartufo/main.jpg";
import one_tartufo_2022 from "../assets/shows_images/2022_tartufo/one.jpg";
import two_tartufo_2022 from "../assets/shows_images/2022_tartufo/two.jpg";
import three_tartufo_2022 from "../assets/shows_images/2022_tartufo/three.jpg";
import four_tartufo_2022 from "../assets/shows_images/2022_tartufo/four.jpg";
import five_tartufo_2022 from "../assets/shows_images/2022_tartufo/five.jpg";
import six_tartufo_2022 from "../assets/shows_images/2022_tartufo/six.jpg";

import main_vantone_2023 from "../assets/shows_images/2023_vantone/main.jpg";
import one_vantone_2023 from "../assets/shows_images/2023_vantone/one.jpg";
import two_vantone_2023 from "../assets/shows_images/2023_vantone/two.jpg";
import three_vantone_2023 from "../assets/shows_images/2023_vantone/three.jpeg";
import four_vantone_2023 from "../assets/shows_images/2023_vantone/four.jpeg";
import five_vantone_2023 from "../assets/shows_images/2023_vantone/five.jpeg";
import six_vantone_2023 from "../assets/shows_images/2023_vantone/six.jpeg";

import main_tartufo_2023 from "../assets/shows_images/2023_tartufo/main.jpg";
import one_tartufo_2023 from "../assets/shows_images/2023_tartufo/one.jpg";
import two_tartufo_2023 from "../assets/shows_images/2023_tartufo/two.jpg";
import three_tartufo_2023 from "../assets/shows_images/2023_tartufo/three.jpg";
import four_tartufo_2023 from "../assets/shows_images/2023_tartufo/four.jpg";
import five_tartufo_2023 from "../assets/shows_images/2023_tartufo/five.jpg";
import six_tartufo_2023 from "../assets/shows_images/2023_tartufo/six.jpg";

import main_menecmi_2023 from "../assets/shows_images/2023_menecmi/main.jpg";
import one_menecmi_2023 from "../assets/shows_images/2023_menecmi/one.jpg";
import two_menecmi_2023 from "../assets/shows_images/2023_menecmi/two.jpg";
import three_menecmi_2023 from "../assets/shows_images/2023_menecmi/three.jpg";
import four_menecmi_2023 from "../assets/shows_images/2023_menecmi/four.jpg";
import five_menecmi_2023 from "../assets/shows_images/2023_menecmi/five.jpg";
import six_menecmi_2023 from "../assets/shows_images/2023_menecmi/six.jpg";

import main_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/main.jpg";
import one_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/one.jpg";
import two_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/two.jpg";
import three_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/three.jpg";
import four_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/four.jpg";
import five_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/five.jpg";
import six_pseudolus_2023 from "../assets/shows_images/2023_pseudolus/six.jpg";

import main_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/main.jpeg";
import one_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/one.jpg";
import two_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/two.jpg";
import three_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/three.jpg";
import four_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/four.jpg";
import five_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/five.jpg";
import six_black_comedy_2024 from "../assets/shows_images/2024_black_comedy/six.jpg";

import main_elena_2024 from "../assets/shows_images/2024_elena/main.jpg";
import one_elena_2024 from "../assets/shows_images/2024_elena/one.jpeg";
import two_elena_2024 from "../assets/shows_images/2024_elena/two.jpeg";
import three_elena_2024 from "../assets/shows_images/2024_elena/three.jpeg";
import four_elena_2024 from "../assets/shows_images/2024_elena/four.jpeg";
import five_elena_2024 from "../assets/shows_images/2024_elena/five.jpeg";
import six_elena_2024 from "../assets/shows_images/2024_elena/six.jpeg";

import main_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/main.jpg";
import one_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/one.jpg";
import two_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/two.jpg";
import three_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/three.jpg";
import four_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/four.jpg";
import five_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/five.jpg";
import six_colore_forma_2024 from "../assets/shows_images/2024_colore_forma/six.jpg";

import main_mandragola_2024 from "../assets/shows_images/2024_mandragola/main.jpg";
import one_mandragola_2024 from "../assets/shows_images/2024_mandragola/one.jpg";
import two_mandragola_2024 from "../assets/shows_images/2024_mandragola/two.jpg";
import three_mandragola_2024 from "../assets/shows_images/2024_mandragola/three.jpg";
import four_mandragola_2024 from "../assets/shows_images/2024_mandragola/four.jpg";
import five_mandragola_2024 from "../assets/shows_images/2024_mandragola/five.jpg";
import six_mandragola_2024 from "../assets/shows_images/2024_mandragola/six.jpg";

import main_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/main.jpg";
import one_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/one.jpg";
import two_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/two.jpg";
import three_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/three.jpg";
import four_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/four.jpg";
import five_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/five.jpg";
import six_uno_nessuno_2025 from "../assets/shows_images/2025_uno_nessuno/six.jpg";

import main_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/main.jpg";
import one_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/one.jpg";
import two_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/two.jpg";
import three_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/three.jpg";
import four_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/four.jpg";
import five_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/five.jpg";
import six_leone_inverno_2025 from "../assets/shows_images/2025_leone_inverno/six.jpg";

const SHOWS = [
  {
    id: "show_id_046",
    date: "2015",
    year: 2015,
    title: "Medeia, Medeias, Medeia",
    author: "Euripide",
    description:
      "L’impossibilità di intendersi fra le diverse civiltà, la difficoltà di uno straniero di integrarsi con gli altri. La solitudine del forestiero, senza passaporto,  spesso perseguitato, senza fissa dimora, simbolo di una umanità che popola  i campi profughi. La madre Medea entra di diritto tra le “madri assassine” che uccidono i loro  figli per meglio distruggere il marito distruggendo anche il loro ruolo di  moglie e di madre. E sono sempre i figli maschi quelli che loro uccidono, togliendo così allo sposo, al marito, la tracotante tranquillità del padre il cui  nome e la stirpe i figli perpetueranno:  'uccidendoli esse distruggono il padre nello sposo'",
    image_main: main_medeia_medeias_2015,
    image_one: one_medeia_medeias_2015,
    image_two: two_medeia_medeias_2015,
    image_three: three_medeia_medeias_2015,
    image_four: four_medeia_medeias_2015,
    image_five: five_medeia_medeias_2015,
    image_six: six_medeia_medeias_2015,
  },
  {
    id: "show_id_047",
    date: "2015/16",
    year: 2015,
    title: "3 donne in cerca di guai",
    author: "Jean Marie Chevret",
    description:
      "Una commedia molto divertente, ma dal retrogusto amaro, dove le vere vincitrici sono le donne, dotate di grande forza e determinazione. Donne capaci di risorgere dalle ceneri del loro passato fallimentare, fatto di delusioni e sconfitte, per dar vita con rinnovato vigore ad un nuovo progetto.  I  temi molto attuali, quali il ruolo della donna nella famiglia, nella società, l’omosessualità,  le difficoltà del  mondo del lavoro, vengono proposti cono garbo ed ironia lasciano alla fine uno  spunto di riflessione. Lo spettacolo ha effettuato più di 200 repliche.",
    image_main: main_tre_donne_2015,
    image_one: one_tre_donne_2015,
    image_two: two_tre_donne_2015,
    image_three: three_tre_donne_2015,
    image_four: four_tre_donne_2015,
    image_five: five_tre_donne_2015,
    image_six: six_tre_donne_2015,
  },
  {
    id: "show_id_048",
    date: "2016",
    year: 2016,
    title: "Medea",
    author: "Euripide",
    description:
      "L’impossibilità di intendersi fra le diverse civiltà, la difficoltà di uno straniero di integrarsi con gli altri. La solitudine del forestiero, senza passaporto,  spesso perseguitato, senza fissa dimora, simbolo di una umanità che popola  i campi profughi. La madre Medea entra di diritto tra le “madri assassine” che uccidono i loro  figli per meglio distruggere il marito distruggendo anche il loro ruolo di  moglie e di madre. E sono sempre i figli maschi quelli che loro uccidono, togliendo così allo sposo, al marito, la tracotante tranquillità del padre il cui  nome e la stirpe i figli perpetueranno:  'uccidendoli esse distruggono il padre nello sposo'",
    image_main: main_medea_2016,
    image_one: one_medea_2016,
    image_two: two_medea_2016,
    image_three: three_medea_2016,
    image_four: four_medea_2016,
    image_five: five_medea_2016,
    image_six: six_medea_2016,
  },
  {
    id: "show_id_049",
    date: "2016",
    year: 2016,
    title: "Sogno di una notte di mezza estate",
    author: "William Shakespeare",
    description:
      "Uno dei capolavori  shakespeariani! Una magica foresta, complice gli incantesimi di Puck, in cui tutto si dissolve, tutto si complica tutto diventa illusione. Un magico luogo in cui l’erotismo si rafforza con la passione e produce turbamento fino a penetrare nella profondità dei cuori rischiando di minare le basi stesse della civile convivenza tra gli uomini. La luce fa disperdere i fantasmi inquietanti che la notte   ha evocato tra i  poeti, gli innamorati e i pazzi coi i “ cervelli  in ebollizione e fervide fantasie ”.  ",
    image_main: main_sogno_mezza_estate_2016,
    image_one: one_sogno_mezza_estate_2016,
    image_two: two_sogno_mezza_estate_2016,
    image_three: three_sogno_mezza_estate_2016,
    image_four: four_sogno_mezza_estate_2016,
    image_five: five_sogno_mezza_estate_2016,
    image_six: six_sogno_mezza_estate_2016,
  },
  {
    id: "show_id_050",
    date: "2017",
    year: 2017,
    title: "4 donne e una canaglia",
    author: "Pierre Chesnot",
    description:
      "In un  gioco di equivoci e  battute sferzanti, le tre dive si misurano con un testo moderno e sagace. Ispirato alla pièce di Pierre Chesnot, lo spettacolo lascia spazio alla vivacità dei dialoghi e al ritmo serrato delle battute",
    image_main: main_quattro_donne_canaglia_2017,
    image_one: one_quattro_donne_canaglia_2017,
    image_two: two_quattro_donne_canaglia_2017,
    image_three: three_quattro_donne_canaglia_2017,
    image_four: four_quattro_donne_canaglia_2017,
    image_five: five_quattro_donne_canaglia_2017,
    image_six: six_quattro_donne_canaglia_2017,
  },
  {
    id: "show_id_051",
    date: "2017",
    year: 2017,
    title: "Menecmi",
    author: "Tito Maccio Plauto",
    description:
      "Spettacolo  basato sul divertentissimo tema degli scambi di persona. Lo spettacolo è una fusione perfetta tra il testo di  Shakespeare (La commedia degli errori)  e il testo plautino (o è forse meglio dire il contrario?). Una fusione perfetta in cui i due autori convivono perfettamente.  Aleggia un’intensa atmosfera avventurosa che il più delle volte rasenta la farsa, per la paradossalità delle situazioni. Quattro gemelli in un vertiginoso scambio  di persone. ",
    image_main: main_menecmi_2017,
    image_one: one_menecmi_2017,
    image_two: two_menecmi_2017,
    image_three: three_menecmi_2017,
    image_four: four_menecmi_2017,
    image_five: five_menecmi_2017,
    image_six: six_menecmi_2017,
  },
  {
    id: "show_id_052",
    date: "2017",
    year: 2017,
    title: "Sogno di una notte di mezza estate",
    author: "William Shakespeare",
    description:
      "Uno dei capolavori  shakespeariani! Una magica foresta, complice gli incantesimi di Puck, in cui tutto si dissolve, tutto si complica tutto diventa illusione. Un magico luogo in cui l’erotismo si rafforza con la passione e produce turbamento fino a penetrare nella profondità dei cuori rischiando di minare le basi stesse della civile convivenza tra gli uomini. La luce fa disperdere i fantasmi inquietanti che la notte   ha evocato tra i  poeti, gli innamorati e i pazzi coi i “ cervelli  in ebollizione e fervide fantasie ”. ",
    image_main: main_sogno_mezza_estate_2017,
    image_one: one_sogno_mezza_estate_2017,
    image_two: two_sogno_mezza_estate_2017,
    image_three: three_sogno_mezza_estate_2017,
    image_four: four_sogno_mezza_estate_2017,
    image_five: five_sogno_mezza_estate_2017,
    image_six: six_sogno_mezza_estate_2017,
  },
  {
    id: "show_id_053",
    date: "2018",
    year: 2018,
    title: "Mostellaria",
    author: "Tito Maccio Plauto",
    description:
      "La grandezza di Plauto non sta soltanto nell’estrema complessità degli intrecci,, ma va ricercata nella capacità di delineare indimenticabili caratteri grotteschi o nel tratto moraleggiante, che talvolta emerge da alcune sue opere minori, ma anche e soprattutto nella lucidità disinvolta con cui ha fatto sfilare sulla scena un’umanità priva di attributi di gloria e di onore, per la quale vige solo la legge dell’inganno finalizzato al proprio piacere o al proprio interesse immediato: homo homini lupus.  ",
    image_main: main_mostellaria_terza_2018,
    image_one: one_mostellaria_terza_2018,
    image_two: two_mostellaria_terza_2018,
    image_three: three_mostellaria_terza_2018,
    image_four: four_mostellaria_terza_2018,
    image_five: five_mostellaria_terza_2018,
    image_six: six_mostellaria_terza_2018,
  },
  {
    id: "show_id_065",
    date: "2019",
    year: 2019,
    title: "Mostellaria",
    author: "Tito Maccio Plauto",
    description:
      "La grandezza di Plauto non sta soltanto nell’estrema complessità degli intrecci,, ma va ricercata nella capacità di delineare indimenticabili caratteri grotteschi o nel tratto moraleggiante, che talvolta emerge da alcune sue opere minori, ma anche e soprattutto nella lucidità disinvolta con cui ha fatto sfilare sulla scena un’umanità priva di attributi di gloria e di onore, per la quale vige solo la legge dell’inganno finalizzato al proprio piacere o al proprio interesse immediato: homo homini lupus.  ",
    image_main: main_mostellaria_2019,
    image_one: one_mostellaria_2019,
    image_two: two_mostellaria_2019,
    image_three: three_mostellaria_2019,
    image_four: four_mostellaria_2019,
    image_five: five_mostellaria_2019,
    image_six: six_mostellaria_2019,
  },
  {
    id: "show_id_054",
    date: "2018",
    year: 2018,
    title: "Due donne in fuga",
    author: "Marisa Laurito",
    description:
      "Lo spettacolo è ricco di  innumerevoli richiami alla vita di oggi, alla situazione della terza età, alla condizione della casalinga più  delle volte frustrata. Lo spettacolo, se pur apparentemente leggero fa sorridere ma anche riflettere sulle piccolezze a cui  siamo legati e, al  tempo stesso in inno alla gioia e alla libertà. Si ride di gusto per l’ironia e l’arguzia delle battute e si sorride nel riconoscere nelle due protagoniste, alcuni aspetti della nostra vita, in un perfetto equilibrio tra commedia e vita vera. Uno spettacolo che porto  nel  cuore soprattutto nel  ricordo della prima edizione con Valeria Valeri e Milena Vukotic.",
    image_main: main_due_donne_fuga_2018,
    image_one: one_due_donne_fuga_2018,
    image_two: two_due_donne_fuga_2018,
    image_three: three_due_donne_fuga_2018,
    image_four: four_due_donne_fuga_2018,
    image_five: five_due_donne_fuga_2018,
    image_six: six_due_donne_fuga_2018,
  },
  {
    id: "show_id_066",
    date: "2019",
    year: 2019,
    title: "Due donne in fuga",
    author: "Marisa Laurito",
    description:
      "Lo spettacolo è ricco di  innumerevoli richiami alla vita di oggi, alla situazione della terza età, alla condizione della casalinga più  delle volte frustrata. Lo spettacolo, se pur apparentemente leggero fa sorridere ma anche riflettere sulle piccolezze a cui  siamo legati e, al  tempo stesso in inno alla gioia e alla libertà. Si ride di gusto per l’ironia e l’arguzia delle battute e si sorride nel riconoscere nelle due protagoniste, alcuni aspetti della nostra vita, in un perfetto equilibrio tra commedia e vita vera. Uno spettacolo che porto  nel  cuore soprattutto nel  ricordo della prima edizione con Valeria Valeri e Milena Vukotic.",
    image_main: main_due_donne_fuga_2019,
  },
  {
    id: "show_id_055",
    date: "2020",
    year: 2020,
    title: "Lysistrata",
    author: "Aristofane",
    description:
      "Regolamentato dalle “condizioni speciali per la messa in scena”, dovuta alla pandemia da corona virus, 3 attori raccontano e vivono la Lisistrata di Aristofane.  E’ un gioco musicale, una gioiosa commedia musicale, dove Lisistrata e i personaggi, aiutati dalle canzoni,  narrando cos’è la guerra,  invitano ad usare “l’antidoto” per la pace: l’amore e il sesso.",
    image_main: main_lysistrata_2020,
    image_one: one_lysistrata_2020,
    image_two: two_lysistrata_2020,
    image_three: three_lysistrata_2020,
    image_four: four_lysistrata_2020,
    image_five: five_lysistrata_2020,
    image_six: six_lysistrata_2020,
  },
  {
    id: "show_id_056",
    date: "2021",
    year: 2021,
    title: "Romeo e Giulietta",
    author: "William Shakespeare",
    description:
      "La definizione di tragedia non sembra molto appropriata a un’opera il cui fascino consiste soprattutto nella suggestione poetica di brani che con la tragedia vera e propria hanno poco a che fare. In realtà è la storia di un amore contrastato, come quello di tante commedie, che si conclude dolorosamente soprattutto per una serie di romanzeschi contrattempi, attribuibili a un destino particolarmente maligno. E’ un ulteriore versione di uno spettacolo nato alcuni  anni  prima e che ha riscontrato un enorme successo. ",
    image_main: main_romeo_giulietta_2021,
    image_one: one_romeo_giulietta_2021,
    image_two: two_romeo_giulietta_2021,
    image_three: three_romeo_giulietta_2021,
    image_four: four_romeo_giulietta_2021,
    image_five: five_romeo_giulietta_2021,
    image_six: six_romeo_giulietta_2021,
  },
  {
    id: "show_id_057",
    date: "2021",
    year: 2021,
    title: "Sette contro Tebe",
    author: "Eschilo",
    description:
      "La tragedia dell’orrore della guerra, del compimento della terribile maledizione del genos di Edipo: la sua stirpe infatti è segnata da antiche colpe che, in una perversa concatenazione di eventi, si riproducono e moltiplicano. Le colpe dei padri, così come i loro meriti, ricadono sempre sui figli. Il testo  ha saputo cristallizzare, con potenza evocativa, il male intrinseco alla vita dell’uomo e la caducità dell’essere umano di fronte al fato. Lo spettacolo è andato è in scena al Festival Dionisiache – Teatro antico  di Segesta",
    image_main: main_sette_contro_tebe_2021,
    image_one: one_sette_contro_tebe_2021,
    image_two: two_sette_contro_tebe_2021,
    image_three: three_sette_contro_tebe_2021,
    image_four: four_sette_contro_tebe_2021,
    image_five: five_sette_contro_tebe_2021,
    image_six: six_sette_contro_tebe_2021,
  },
  {
    id: "show_id_058",
    date: "2022",
    year: 2022,
    title: "Il Vantone",
    author: "Tito Maccio Plauto",
    description:
      "E’ un testo in versi settenari in rima baciata che, a nostro parere, riesce a mantenere non solo la fedeltà al testo di Plauto ma recuperando espressioni volgari e gergali ne recupera l’anima originaria sia dell’autore che del periodo storico culturale plautino.  Il testo riproduce fedelmente il Miles Gloriosus di Plauto in ogni suo passaggio ma la forza del dialetto riesce a recuperare in tutti i passaggi drammaturgici la potenza della farsa/commedia che altro non è che la rappresentazione esasperata della quotidianità.",
    image_main: main_vantone_2022,
    image_one: one_vantone_2022,
    image_two: two_vantone_2022,
    image_three: three_vantone_2022,
    image_four: four_vantone_2022,
    image_five: five_vantone_2022,
    image_six: six_vantone_2022,
  },
  {
    id: "show_id_059",
    date: "2022",
    year: 2022,
    title: "Rigoletto",
    author: "Giuseppe Verdi",
    description: "",
    image_main: main_rigoletto_2022,
  },

  {
    id: "show_id_060",
    date: "2022",
    year: 2022,
    title: "Sette contro Tebe",
    author: "Eschilo",
    description:
      "Ripresa dello  spettacolo andato in scena  al Festival Dionisiache 2021. La ripresa al  Teatro Greco Romano del Parco Archeologico Nazionale di Locri Epizefiri. L’evento teatrale, promosso dalla Città metropolitana di Reggio Calabria con la collaborazione della Direzione regionale Musei Calabria e dei Comuni di Locri e Portigliola nell’ambito delle celebrazioni per il 50° anniversario del ritrovamento dei Bronzi di Riace.",
    image_main: main_sette_contro_tebe_2022,
  },
  {
    id: "show_id_061",
    date: "2022",
    year: 2022,
    title: "Tartufo",
    author: "Moliere",
    description:
      "Una satira pungente, una commedia di grande attualità. E il Tartufo è l'emblema dell'ipocrisia, che vive dietro l'apparenza della devozione religiosa e dell'amicizia, approfittando della fiducia altrui, tradendola senza scrupolo, per trarne vantaggio. L'ipocrisia, il plagio, la falsità, contrabbandati cosi sotto la maschera della virtù, rappresentano i mali che l'uomo coltiva da sempre e che fanno parte della sua natura. Tutti i giorni ci imbattiamo in un 'tartufo': quest'uomo non può né esaurirsi, né estinguersi. Lo spettacolo è in una nuova versione della precedente edizione del 2013.",
    image_main: main_tartufo_2022,
    image_one: one_tartufo_2022,
    image_two: two_tartufo_2022,
    image_three: three_tartufo_2022,
    image_four: four_tartufo_2022,
    image_five: five_tartufo_2022,
    image_six: six_tartufo_2022,
  },
  {
    id: "show_id_062",
    date: "2022",
    year: 2022,
    title: "Per fortuna è una notte di luna",
    author: "Gianni Clementi",
    description:
      "E’ il 21 luglio del 1969…. è una notte di luna. Sulla terrazza di un palazzo signorile, un muratore sta lavorando ad un manufatto abusivo. I personaggi tutti facenti parte della stessa famiglia stanno allestendo lo spazio all’aperto, per assistere insieme all’evento televisivo dell’allunaggio. Lo spettacolo  non solo è il racconto “dilatato” nel tempo della famiglia Palmieri ma è anche la narrazione di un popolo che fa ancora fatica a orientarsi dopo Piazza Fontana o dopo il ritrovamento del corpo di Aldo Moro a via Caetani. E’ soprattutto la storia “difficile e conflittuale” di una famiglia come tante che pur essendo agiata vive i molti problemi legati ai rapporti personali, al non  dialogo e incomprensioni che devono far i conti con le singole paure e frustrazioni. Un finale amarissimo alla fine di  in questo allestimento ci porterà tutti con i piedi per  terra davanti  ad una delle più crude realtà del nostro secolo.  ",
    image_main: main_fortuna_notte_luna_2022,
    image_one: one_fortuna_notte_luna_2022,
    image_two: two_fortuna_notte_luna_2022,
    image_three: three_fortuna_notte_luna_2022,
    image_four: four_fortuna_notte_luna_2022,
    image_five: five_fortuna_notte_luna_2022,
    image_six: six_fortuna_notte_luna_2022,
  },
  {
    id: "show_id_063",
    date: "2022",
    year: 2022,
    title: "Rumori fuori scena",
    author: "Michael Frayn",
    description:
      "Rumori fuori scena è un cult del teatro contemporaneo, uno straordinario esempio di meta-teatro: del mondo del palcoscenico e in particolare del “dietro le quinte” sbeffeggia ripicche e rivalità, tic, interruzioni, errori, crisi di nervi, tensioni, amorazzi e riappacificazioni che rischiano continuamente di compromettere l’andata in scena dello spettacolo. Fanno da padroni i temi cari alla Commedia dell’Arte e Commedia plautina di travestimenti,  equivoci, scambi di persona, un susseguirsi di risate e di folli equivoci , di gag pirotecniche. U piccolo gioiello, un meccanismo ad alta precisione in cui ogni elemento funziona in maniera perfetta, è una delle più interessanti operazioni di teatro nel teatro che sopravvive da quasi 40 anni. La trama prende spunto da una sgangherata compagnia teatrale alle prese con la prova generale di una commedia degli errori, farcita da porte che aprono e porte che si chiudono mettendo in ridicolo i tipici meccanismi della commedia borghese",
    image_main: main_rumori_fuori_scena_2022,
    image_one: one_rumori_fuori_scena_2022,
    image_two: two_rumori_fuori_scena_2022,
    image_three: three_rumori_fuori_scena_2022,
    image_four: four_rumori_fuori_scena_2022,
    image_five: five_rumori_fuori_scena_2022,
    image_six: six_rumori_fuori_scena_2022,
  },
  {
    id: "show_id_067",
    date: "2023",
    year: 2023,
    title: "Il Vantone",
    author: "Tito Maccio Plauto",
    description:
      "E’ un testo in versi settenari in rima baciata che, a nostro parere, riesce a mantenere non solo la fedeltà al testo di Plauto ma recuperando espressioni volgari e gergali ne recupera l’anima originaria sia dell’autore che del periodo storico culturale plautino.  Il testo riproduce fedelmente il Miles Gloriosus di Plauto in ogni suo passaggio ma la forza del dialetto riesce a recuperare in tutti i passaggi drammaturgici la potenza della farsa/commedia che altro non è che la rappresentazione esasperata della quotidianità.",
    image_main: main_vantone_2023,
    image_one: one_vantone_2023,
    image_two: two_vantone_2023,
    image_three: three_vantone_2023,
    image_four: four_vantone_2023,
    image_five: five_vantone_2023,
    image_six: six_vantone_2023,
  },
  {
    id: "show_id_064",
    date: "2023",
    year: 2023,
    title: "Tartufo",
    author: "Moliere",
    description:
      "Una satira pungente, una commedia di grande attualità. E il Tartufo è l'emblema dell'ipocrisia, che vive dietro l'apparenza della devozione religiosa e dell'amicizia, approfittando della fiducia altrui, tradendola senza scrupolo, per trarne vantaggio. L'ipocrisia, il plagio, la falsità, contrabbandati cosi sotto la maschera della virtù, rappresentano i mali che l'uomo coltiva da sempre e che fanno parte della sua natura. Tutti i giorni ci imbattiamo in un 'tartufo': quest'uomo non può né esaurirsi, né estinguersi. Lo spettacolo è in una nuova versione della precedente edizione del 2013.",
    image_main: main_tartufo_2023,
    image_one: one_tartufo_2023,
    image_two: two_tartufo_2023,
    image_three: three_tartufo_2023,
    image_four: four_tartufo_2023,
    image_five: five_tartufo_2023,
    image_six: six_tartufo_2023,
  },
  {
    id: "show_id_065",
    date: "2023",
    year: 2023,
    title: "Menecmi",
    author: "Tito Maccio Plauto",
    description:
      "Lo spettacolo,  basato sul divertentissimo tema degli scambi di persona, è una fusione perfetta tra il testo di  Shakespeare (La commedia degli errori)  e il testo plautino (o è forse meglio dire il contrario?). Una fusione perfetta in cui i due autori convivono perfettamente.  Aleggia un’intensa atmosfera avventurosa che il più delle volte rasenta la farsa, per la paradossalità delle situazioni. Quattro gemelli in un vertiginoso scambio  di persone. Questa edizione è stata presente  al Festival del Teatro Classico di Formia, al Plautus Festival di Sarsina e al Festival MediterrArtè a Catania e Siracusa. Lo spettacolo ha debuttato per la prima volta 23 anni fà per il Festival di Segesta, direttore artistico Michele La Tona, ed ha avuto tra i protagonisti, al  suo debutto teatrale,  Ambra Angiolini. Menecmi ad oggi ha visto 7 edizioni con 4 compagnie diverse.",
    image_main: main_menecmi_2023,
    image_one: one_menecmi_2023,
    image_two: two_menecmi_2023,
    image_three: three_menecmi_2023,
    image_four: four_menecmi_2023,
    image_five: five_menecmi_2023,
    image_six: six_menecmi_2023,
  },
  {
    id: "show_id_066",
    date: "2023",
    year: 2023,
    title: "Pseudolus",
    author: "Tito Maccio Plauto",
    description:
      "Lo spettacolo,  basato sul divertentissimo tema degli scambi di persona, è una fusione perfetta tra il testo di  Shakespeare (La commedia degli errori)  e il testo plautino (o è forse meglio dire il contrario?). Una fusione perfetta in cui i due autori convivono perfettamente.  Aleggia un’intensa atmosfera avventurosa che il più delle volte rasenta la farsa, per la paradossalità delle situazioni. Quattro gemelli in un vertiginoso scambio  di persone. Questa edizione è stata presente  al Festival del Teatro Classico di Formia, al Plautus Festival di Sarsina e al Festival MediterrArtè a Catania e Siracusa. Lo spettacolo ha debuttato per la prima volta 23 anni fà per il Festival di Segesta, direttore artistico Michele La Tona, ed ha avuto tra i protagonisti, al  suo debutto teatrale,  Ambra Angiolini. Menecmi ad oggi ha visto 7 edizioni con 4 compagnie diverse.",
    image_main: main_pseudolus_2023,
    image_one: one_pseudolus_2023,
    image_two: two_pseudolus_2023,
    image_three: three_pseudolus_2023,
    image_four: four_pseudolus_2023,
    image_five: five_pseudolus_2023,
    image_six: six_pseudolus_2023,
  },
  {
    id: "show_id_067",
    date: "2024",
    year: 2024,
    title: "Black Comedy",
    author: "Peter Shaffer",
    description:
      "Una commedia degli errori in salsa anglosassone. Una farsa corale e rocambolesca ambientata nell’appartamento londinese del giovane scultore Brindsley Miller, rimasto interamente al buio a causa di un black out che crea situazioni esilaranti e a tratti imbarazzanti. La pièce porta quel timbro leggero e tipico della commedia anglosassone con situazioni paradossali e comportamenti bizzarri che si innescano a partire da un primo equivoco. Un testo di raffinato divertimento sia per il pubblico sia per  chi lo mette in scena.",
    image_main: main_black_comedy_2024,
    image_one: one_black_comedy_2024,
    image_two: two_black_comedy_2024,
    image_three: three_black_comedy_2024,
    image_four: four_black_comedy_2024,
    image_five: five_black_comedy_2024,
    image_six: six_black_comedy_2024,
  },
  {
    id: "show_id_068",
    date: "2024",
    year: 2024,
    title: "Elena",
    author: "Euripide",
    description:
      "Tra tutte le tragedie euripidee, quella dedicata a Elena è la più trasgressiva e innovativa: rovescia il mito di Elena. Euripide mette in scena la personificazione della traditrice per eccellenza e ne fa una donna ideale, fedele a Menelao e madre piena di rimpianti per aver abbandonato la figlia Ermione. Spogliata dal mito e dalla tradizione, la vera  Elena per Euripide è stata condotta per volere degli dèi in Egitto, dove protetta dal re Proteo è rimasta fedele al marito, mentre a Troia, con Paride, vive un fantasma, fabbricato d’aria, in tutto e per tutto identico ad Elena.  Euripide si diverte a complicare la trama, già di per se sorprendente nell’incostante oscillazione delle responsabilità divine e umane, creando un crescendo di situazioni al limite del surreale, fino ad un imbroglio che permette ad Elena e Menelao, nel frattempo entrato anche lui nel  vortice della trama, di lasciare l’Egitto. L’impossibilità di distinguere tra apparenza e realtà e di conoscere la verità che emergono dal prologo si riveleranno un vero e proprio leitmotiv della tragedia. E’ una tragedia anomala dato che la sua struttura drammaturgica l’allontana dalle altre tragedia sia per contenuti che per forma. Di satira e di scene umoristiche ne sono piene le pagine di questa Elena euripidea. ",
    image_main: main_elena_2024,
    image_one: one_elena_2024,
    image_two: two_elena_2024,
    image_three: three_elena_2024,
    image_four: four_elena_2024,
    image_five: five_elena_2024,
    image_six: six_elena_2024,
  },
  {
    id: "show_id_069",
    date: "2024",
    year: 2024,
    title: "Il colore della forma",
    author: "Marco Schiavon",
    description:
      "Lo spettacolo, attraverso la vita di Gino Rossi uno dei  massimi esponenti dell’arte pittorica italiana degli inizi del novecento, affronta il tema della follia e creatività. L’arte della pittura come luogo mentale del protagonista e suo spazio di libertà si contrappone al manicomio come luogo carcerario degli avvenimenti, producendo la contraddizione a fondamento del testo. Parallelamente ai suoi quadri, proiettati e scomposti su una scena nuda, lo spettacolo analizza  come il  rapporto tra genio e follia, sia stato fondamentale nella sua vita. Il protagonista all’interno del manicomio, dove l’artista (recluso per più di 25 anni fino alla sua morte), si relaziona  e dialoga con i vari personaggi, reali e non,  sull’arte pittorica e i colori che ad essa danno forma, affrontando sia le sue vicissitudine umane e artistiche che hanno influenzato le sue scelte pittoriche dal postimpressionismo al cubismo. Lo spettacolo è una riflessione sull’importanza del colore (forma di energia che agisce su tutto il nostro essere, fisico, mentale e spirituale)  e su come i colori influiscano sulle nostre azioni e sui nostri stati emotivi.  Testo vincitore del premio Cendic-Segesta 2018.",
    image_main: main_colore_forma_2024,
    image_one: one_colore_forma_2024,
    image_two: two_colore_forma_2024,
    image_three: three_colore_forma_2024,
    image_four: four_colore_forma_2024,
    image_five: five_colore_forma_2024,
    image_six: six_colore_forma_2024,
  },
  {
    id: "show_id_070",
    date: "2024",
    year: 2024,
    title: "Mandragola",
    author: "Niccolò Machiavelli",
    description:
      "Capolavoro del teatro del Cinquecento, un classico della drammaturgia italiana. La Mandragola è una potente satira sulla corruttibilità della società italiana dell'epoca. Un’epoca quella del 1518 in cui la Controriforma luterana si contrapponeva al potere temporale del Papa e al mercimonio delle indulgenze che arricchiva le casse della chiesa di Roma. La Mandragola,  seppur sotto le sembianze di un'ilare commedia, svolge un ruolo di denuncia nei confronti della totale perdita di morale della società del tempo, mette in discussione i valori familiari,  inducendo nello spettatore un riso serio e quasi acre, che fa assai riflettere e critica la politica papale.  Una commedia  grottesca, ironica  dove, per la prima volta nella storia della drammaturgia italiana, un triangolo amoroso si trasforma in materiale narrativo: un vecchio marito stupido e presuntuoso, pur di diventare padre,  accetta di esser fatto “becco” da un giovane vigoroso e da una giovane moglie che tutto era tranne che virtuosa.  Ogni “mezzo giustifica il fine” sottolinea Machiavelli.",
    image_main: main_mandragola_2024,
    image_one: one_mandragola_2024,
    image_two: two_mandragola_2024,
    image_three: three_mandragola_2024,
    image_four: four_mandragola_2024,
    image_five: five_mandragola_2024,
    image_six: six_mandragola_2024,
  },
  {
    id: "show_id_071",
    date: "2025",
    year: 2025,
    title: "Uno, Nessuno, Centomila",
    author: "Luigi Pirandello",
    description:
      "Ironico, grottesco,  rivoluzionario, capace di mettere in crisi la società borghese del primo novecento. L'ultimo dei romanzi di Pirandello  è  denso di enigmi, e secondo lo stesso autore esso è «sintesi completa di tutto ciò che ho fatto e la sorgente di quello che farò». In una lettera autobiografica, Pirandello lo definisce come il romanzo 'più amaro di tutti, profondamente umoristico, di scomposizione della vita'. Il protagonista Vitangelo Moscarda è forse uno dei personaggi più complessi della produzione pirandelliana: 'prima impacciato e prigioniero delle opinioni altrui, poi sempre più consapevole e determinato a cercare l’autenticità spirituale dell’esistenza , fino all'affrancamento finale da tutte 'le rabbie del mondo. Un impianto scenografico in movimento, un gruppo di cinque straordinari attori e l’umorismo tipico in Pirandello, ci raccontano questa storia ancora oggi di grandissima attualità. ",
    image_main: main_uno_nessuno_2025,
    image_one: one_uno_nessuno_2025,
    image_two: two_uno_nessuno_2025,
    image_three: three_uno_nessuno_2025,
    image_four: four_uno_nessuno_2025,
    image_five: five_uno_nessuno_2025,
    image_six: six_uno_nessuno_2025,
  },
  {
    id: "show_id_072",
    date: "2025",
    year: 2025,
    title: "Il leone d'inverno",
    author: "James Goldman",
    description:
      "Come in tutte le famiglie che si rispettino, a Natale scoppiano le tensioni, scoperchiando nidi di vipere e insidie d’ogni specie. Questa però non è una famiglia qualsiasi. Sono il re Enrico II d’Inghilterra e la regina Eleonora d’Aquitania, con i loro figli Riccardo, Goffredo, Giovanni.  Siamo nel castello di Chinon alla vigilia di Natale del 1183 e lo scontro titanico avviene per la successione al trono. A immaginare tutto questo ci prova Goldman, con effetti sorprendenti e accattivanti. Affetti da voyeurismo antropico sbirciamo e gustiamo le diatribe che l’autore ha inventato alla corte inglese, ossatura del suo dramma ispirato a fonti storiche. Gustiamo in un crescendo dinamico l’intimo dissidio familiare dai toni esacerbati, che lascia intravvedere l’abisso in cui sono precipitati i ‘nobili signori’, travolti da complotti, rancori, rivalità, vendette, passioni. La lotta per la successione al trono scatena odio e cattiveria fuor di misura. Padri contro figli, figli contro padri, fratelli contro fratelli, marito contro moglie, tenuta prigioniera dal fedifrago che intanto coltiva una passione sfrenata per la giovanissima Alais, sorella di Filippo II re di Francia; giocano tutti una partita senza esclusione di colpi. ",
    image_main: main_leone_inverno_2025,
    image_one: one_leone_inverno_2025,
    image_two: two_leone_inverno_2025,
    image_three: three_leone_inverno_2025,
    image_four: four_leone_inverno_2025,
    image_five: five_leone_inverno_2025,
    image_six: six_leone_inverno_2025,
  },
];

export default SHOWS;

let lastItem = SHOWS[SHOWS.length - 1];
export { lastItem };
